
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Chemistry: Atoms First 1e */ '4539ae23-1ccc-421e-9b25-843acbb6c4b0': [
    /* Chemistry: Atoms First 2e */ ['d9b85ee6-c57f-4861-8208-5ddf261e9c5f', {
      /* Preface to the same module in 2e */
      'f47f9c6a-e937-4e8f-a817-c11d4f8eff59': '541d7d79-a70e-42c2-b765-d55586648390',
      /* 1.0 Introduction to the same module in 2e */
      'b9783491-46be-4295-827c-3f3b1c5c7ded': '0d8fa7a1-89a1-46a8-b340-aa25a6093908',
      /* 1.1 Chemistry in Context to the same module in 2e */
      '1afd5b29-c2ad-4168-9c4a-86554aa47e4d': 'e4d0a888-2602-4b89-ae08-c1abd498a239',
      /* 1.2 Phases and Classification of Matter to the same module in 2e */
      '8d797b3b-588a-41d5-b81b-95f1e228f12b': '7d9dde51-8917-4f91-8cbb-24f7712c80dd',
      /* 1.3 Physical and Chemical Properties to the same module in 2e */
      '2bc1b136-d284-486c-90fa-1bbcf5324603': 'dfdd5419-1eac-4c06-a0af-e73023e6b015',
      /* 1.4 Measurements to the same module in 2e */
      '1823d29c-ebb0-4040-964b-95dc6ba8ba69': '8f4e1efc-5485-4cd0-b213-d33c9be94310',
      /* 1.5 Measurement Uncertainty, Accuracy, and Precision to the same module in 2e */
      '31204b0d-7cc0-4cb7-bdeb-87a49c2e6bc1': 'daeefb73-f141-4612-ae40-d4915efc253d',
      /* 1.6 Mathematical Treatment of Measurement Results to the same module in 2e */
      'a92c91af-af65-4609-8c39-b07ee8762715': '9de27337-c22d-40d7-a59e-270d1a6c7b00',
      /* 2.0 Introduction to the same module in 2e */
      'd9d70793-82ff-417a-bb59-c883272e6877': '1cb2b2cb-c17a-4cee-b972-13ebc03f7627',
      /* 2.1 Early Ideas in Atomic Theory to the same module in 2e */
      '0b8b9f6c-0e47-4e30-9b6f-7ab7c3ea17bd': 'ebfab4d3-9644-41b8-80fc-a67ba47c0f57',
      /* 2.2 Evolution of Atomic Theory to the same module in 2e */
      '9a317974-756f-49a3-aa95-8138225621ab': 'c3dccc36-8ede-466f-b216-f05018a4e088',
      /* 2.3 Atomic Structure and Symbolism to the same module in 2e */
      'b8e5ad9b-3e8e-4e26-95e1-0a19e833793e': '77398b85-782d-4a36-b0a6-a0959dbf9c60',
      /* 2.4 Chemical Formulas to the same module in 2e */
      'd43bc0be-c1be-48fe-a428-ac920a056d11': '594e5009-d70c-4101-ae18-4154ff1c7ffd',
      /* 3.0 Introduction to the same module in 2e */
      '0c8058a7-c911-41ce-8b70-06a137cb8278': 'fc7f7fc6-4d9f-4956-a5a7-3092ac72182e',
      /* 3.1 Electromagnetic Energy to the same module in 2e */
      'bf85a0ac-aa61-45e6-a28a-84248d678caa': 'd96495d5-09fe-4702-959f-d39a243c2612',
      /* 3.2 The Bohr Model to the same module in 2e */
      'e40d0565-97be-4ad3-bdaa-61c022f1dc47': '7af45a79-c893-4289-9ecb-13be48b76983',
      /* 3.3 Development of Quantum Theory to the same module in 2e */
      '7c28ed3f-5b25-4ed9-bfbe-d20ff5647509': '11dd0544-b543-4912-aeac-4879dd964ec0',
      /* 3.4 Electronic Structure of Atoms (Electronic Configurations) to the same module in 2e */
      'efcbdbdb-080a-4dc0-837e-57ac444ca2d0': '627e5a5b-94a9-4069-b2a0-7a446ea165cf',
      /* 3.5 Periodic Variations in Element Properties to the same module in 2e */
      '6e87578e-8471-4d2c-9761-b7ab5e319ad1': 'c9c8f370-dce6-4fb9-ae62-f36f87a900f0',
      /* 3.6 The Periodic Table to the same module in 2e */
      'dd3d1fd5-5447-4b3e-8385-f44fe82bc453': '4d73981f-76cf-43a3-b932-9f68fdf3abf6',
      /* 3.7 Molecular and Ionic Compounds to the same module in 2e */
      '30baba83-9efc-4f3c-9bff-911cfb057a5b': 'b832199d-447d-4c4b-b05b-af31e4297fa6',
      /* 4.0 Introduction to the same module in 2e */
      'be5f4d96-4f69-4393-86c5-43d48604fb0b': 'b86288d5-f029-45ac-a301-2320aa86cb5b',
      /* 4.1 Ionic Bonding to the same module in 2e */
      '18569bcc-2710-4eb3-aad0-811595ddd5f3': '15fcaa15-d7e8-4c4b-a448-20ea312b13ff',
      /* 4.2 Covalent Bonding to the same module in 2e */
      'e50d435d-cb14-4c9a-accb-e746f61795fc': '1e445aa2-713a-496d-8052-c6008a85677c',
      /* 4.3 Chemical Nomenclature to the same module in 2e */
      '7e1013d7-221b-48d9-8bc3-a8a9ed5840c1': 'af022e7e-64ba-4771-aca4-0cde75b66925',
      /* 4.4 Lewis Symbols and Structures to the same module in 2e */
      'bafa441e-6217-478e-bf89-356295080cb5': '5b667ac9-afd2-4a51-b96b-9a86d58beef7',
      /* 4.5 Formal Charges and Resonance to the same module in 2e */
      '5bfd0328-d151-45b7-8c22-455aa0c36157': 'bdd8ac14-71e8-4a87-9cc7-361f0a3157c2',
      /* 4.6 Molecular Structure and Polarity to the same module in 2e */
      '1a7fcf57-8f3a-430a-a1bf-cdbdea263263': 'ff774d31-ee45-4f0d-a362-fdd00c5f17da',
      /* 5.0 Introduction to the same module in 2e */
      '1322482c-0b50-42ba-9df3-aa2e04a7ccba': '5ed46911-a4b7-4944-b746-f224f5031db4',
      /* 5.1 Valence Bond Theory to the same module in 2e */
      '2318b880-2e7a-4bd0-a01e-8019bc00795c': '74586eeb-8131-4a48-b32a-d285cbfba707',
      /* 5.2 Hybrid Atomic Orbitals to the same module in 2e */
      'd66bef54-c39a-4b1c-a9fd-985ac997422e': '5b3f5309-5e19-417e-8753-5d01b5f26ad4',
      /* 5.3 Multiple Bonds to the same module in 2e */
      '55de0e84-2c62-4f1b-9c3b-2cfd5dee3bba': '51189d7f-2047-4987-aa94-7b8edd91e13d',
      /* 5.4 Molecular Orbital Theory to the same module in 2e */
      '7b121f61-848e-4591-9bf9-2399cf52df50': '58805a0c-1013-44b7-837a-878cece9de6b',
      /* 6.0 Introduction to the same module in 2e */
      '96906eea-9398-4937-b72f-221b9e49f6b9': '9a3bd412-d571-4c1f-a985-06fbfc32bfbd',
      /* 6.1 Formula Mass and the Mole Concept to the same module in 2e */
      'c92f6dd8-774c-4d2c-af2b-d7aa3374b237': 'd5516242-4416-4339-adc7-5a7461140d6d',
      /* 6.2 Determining Empirical and Molecular Formulas to the same module in 2e */
      '09f12b7c-7a74-406c-b0d9-81c01be5db08': '3c929abd-8cc0-4267-a017-a508815dac43',
      /* 6.3 Molarity to the same module in 2e */
      'e3597d1f-f348-4acc-9bdd-6f55f3e74158': '3ca3a877-a8ba-42f7-a101-7035c0f5daed',
      /* 6.4 Other Units for Solution Concentrations to the same module in 2e */
      '79bad7f9-b882-4863-9808-c7db61331efa': '4fee0e14-2169-4e3b-bb15-def8b056b1a0',
      /* 7.0 Introduction to the same module in 2e */
      '40fa4a2d-3d40-48d0-baa8-75b426e7ddeb': '69a85723-e8a2-4655-b514-b05dd8acf81d',
      /* 7.1 Writing and Balancing Chemical Equations to the same module in 2e */
      '38f51912-b221-4554-a24b-33bc9ff3df5b': '824e8777-c9bf-46b1-b232-d0bc764f4729',
      /* 7.2 Classifying Chemical Reactions to the same module in 2e */
      '92ff9837-62af-4f39-8db8-f4d368a0f746': '24424d00-3cc4-445d-a830-ad38abcea953',
      /* 7.3 Reaction Stoichiometry to the same module in 2e */
      '1ceb13be-e7cc-49ac-9386-8c6dffc6e668': '23c22d4a-5468-45b5-a3ee-616ae2549e96',
      /* 7.4 Reaction Yields to the same module in 2e */
      '0c09d622-b8b8-4099-923d-102d137bbb35': '3da1a637-2826-47bf-8b06-e32ffbdfd60a',
      /* 7.5 Quantitative Chemical Analysis to the same module in 2e */
      '83acd5ca-a80b-40af-9160-8845a990cb04': '2a580143-0495-4282-a0fd-8ee1eef2a57f',
      /* 8.0 Introduction to the same module in 2e */
      'e16c326f-3d84-426d-b6a0-a96964518891': '9a9ae0b1-98f9-4635-a5a6-34c7e3e747c1',
      /* 8.1 Gas Pressure to the same module in 2e */
      '366e9bcf-5ea9-40fb-8acf-a5c30f405c2b': 'b4305959-0bef-4283-8145-f9184c9652d3',
      /* 8.2 Relating Pressure, Volume, Amount, and Temperature: The Ideal Gas Law to the same module in 2e */
      '7b8b7046-8f1c-43ab-a18e-2b354e1fc130': '1f39d5df-ef6a-43de-a533-117a5dc92f44',
      /* 8.3 Stoichiometry of Gaseous Substances, Mixtures, and Reactions to the same module in 2e */
      '1a4a6358-3295-47ab-ac23-4a337413cd4c': '184a65b2-1f3f-49dc-bf1d-7d4a12d21ae9',
      /* 8.4 Effusion and Diffusion of Gases to the same module in 2e */
      '8e586ebc-1ca7-4908-9abf-10c4dadd4b81': '43c287f6-81a2-4372-a312-528f3b1f4c2a',
      /* 8.5 The Kinetic-Molecular Theory to the same module in 2e */
      '89c575da-4772-47e8-87a5-1de83be6a38c': '4e7fd664-a228-4ce5-ac39-cec1b6b516b3',
      /* 8.6 Non-Ideal Gas Behavior to the same module in 2e */
      'ace251f8-a940-4d1d-b6d9-7f4657265bb7': '6c7ade02-773b-44d1-945a-61ae6b0cc79b',
      /* 9.0 Introduction to the same module in 2e */
      'ca2ae7ca-1185-4085-b9dd-4948b4e64813': 'ee59d5c7-6a07-464c-9e56-b99ffdf874ea',
      /* 9.1 Energy Basics to the same module in 2e */
      '07a5fdb5-9d69-4d93-abdc-44e8fd4da14c': 'fae98e81-a194-4023-9468-aafca1dc4674',
      /* 9.2 Calorimetry to the same module in 2e */
      '0d364b67-be96-44fc-bee5-a368a42c2c82': 'b558e108-5a6c-4e5c-83a1-b9863c1321c9',
      /* 9.3 Enthalpy to the same module in 2e */
      '32baaf18-04e0-428f-8205-fadbbeb0cc87': 'f0da1d6f-9177-44cb-aa2a-4928116abfee',
      /* 9.4 Strengths of Ionic and Covalent Bonds to the same module in 2e */
      'fab49b60-08b2-49f0-9528-366ba8d0bac6': '2b8e2876-209c-449d-9f2c-abbd73900c8b',
      /* 10.0 Introduction to the same module in 2e */
      'e7694089-f2ac-4cd3-90d3-03de3f941e56': 'd8f61820-f7cc-479e-8e83-a1c7ac0f2a26',
      /* 10.1 Intermolecular Forces to the same module in 2e */
      '1a375cfb-8275-40e8-9aa4-70e67c661187': '3bd0cfe0-4bfc-4a11-978a-eeacf9dc5c0b',
      /* 10.2 Properties of Liquids to the same module in 2e */
      '5a020d86-5a57-4873-8464-84c03137cdc8': '846e6c50-e81e-4658-b938-857b5169e73c',
      /* 10.3 Phase Transitions to the same module in 2e */
      '512249ee-4307-44ff-8106-730e878b0a73': '3f0fa9fb-278f-4fae-9a77-661bbd8c466a',
      /* 10.4 Phase Diagrams to the same module in 2e */
      'd1927b38-14fa-451f-b0ba-11defdef62c8': '23152758-9f27-4c49-91a6-0f989a5d8d7b',
      /* 10.5 The Solid State of Matter to the same module in 2e */
      '04dab336-2027-4d79-87d1-88a95aa78377': 'eb0edc08-a7a0-4b1f-89d5-b7f5721ff192',
      /* 10.6 Lattice Structures in Crystalline Solids to the same module in 2e */
      '11636092-77ed-4b50-910c-37a3b38e928b': 'a8b4c42a-9ddf-4669-9143-2c4feec1dbff',
      /* 11.0 Introduction to the same module in 2e */
      '107e0db4-112a-458d-954e-7976622b24cc': 'f0d28fa7-9058-4391-917a-e6fa0fba640a',
      /* 11.1 The Dissolution Process to the same module in 2e */
      '987e9aa9-e831-4cfd-9d0a-60e48afe8f22': 'c6004026-5f7c-4474-81ca-2b52ef029d8b',
      /* 11.2 Electrolytes to the same module in 2e */
      'dd95f8bf-3cb7-4fbf-ab37-8ea13df86881': 'ddeb42d9-e09a-4c0c-afd0-633c0bf6b125',
      /* 11.3 Solubility to the same module in 2e */
      'db8f3c7d-6e96-4ad8-b059-7782a7fcca22': '92f7d520-699c-4ac6-8fc7-8f99c4aaee33',
      /* 11.4 Colligative Properties to the same module in 2e */
      '19426b1d-2561-4f8b-bdb6-1c15d8a8b35d': '41124640-ce56-4231-9851-d5169f64335f',
      /* 11.5 Colloids to the same module in 2e */
      '56beb5c5-0dc9-43b4-8d38-a856011c797e': '3165251d-5ef8-4e94-8d53-6c48a9aa3cd3',
      /* 12.0 Introduction to the same module in 2e */
      '6771dc91-493a-43e2-945b-3faa307e6280': '87dd32cb-8083-4283-9eb6-c6da06348095',
      /* 12.1 Spontaneity to the same module in 2e */
      '1ec31480-5f54-4666-9f50-50c208b22688': '2ede4220-1cbf-413c-a0b2-fe8139651991',
      /* 12.2 Entropy to the same module in 2e */
      '7e9bd00b-acd2-4dc7-af8c-7140fb483196': 'e027dead-a283-48fa-bf2c-f6e7ad70b3ec',
      /* 12.3 The Second and Third Laws of Thermodynamics to the same module in 2e */
      '8f245eea-8953-4178-bc10-432e74017ae0': '84ae472c-bdb6-4a46-a97c-c97304f6f406',
      /* 12.4 Free Energy to the same module in 2e */
      'fc834a98-b464-44ac-b5c6-49afb9c1b380': '48d01599-d83d-494a-9d7f-b64e72f7d3e2',
      /* 13.0 Introduction to the same module in 2e */
      '0ee268fc-3252-4d25-a43e-b5a7b8610389': '4c2a35c8-ed8c-429c-9e49-25e0d3003bdc',
      /* 13.1 Chemical Equilibria to the same module in 2e */
      '53f4eb7c-0dac-4102-b84d-bee669eedf93': '5ba4be2f-b0d1-4b87-a65c-ddd234dda79e',
      /* 13.2 Equilibrium Constants to the same module in 2e */
      '869fa880-bae2-4a92-97c9-4a89f32c7855': '7ce6feca-8547-47b6-9b12-f4b32969da5b',
      /* 13.3 Shifting Equilibria: Le Châtelier's Principle to the same module in 2e */
      'b7af3647-cf70-46c6-a129-7b45e0ef269f': '023b68f9-1ea7-45cf-9911-25c1af3aa3ad',
      /* 13.4 Equilibrium Calculations to the same module in 2e */
      '9b03c475-e34a-4b96-8d3f-309ff3bcbc76': '37feaf08-2a93-4dbe-84c4-140d213f9b5c',
      /* 14.0 Introduction to the same module in 2e */
      '5215a06f-49fb-43dd-8e35-9bc5ac98d180': '4abeb29f-5f24-4945-8beb-2c9c56c8d9bc',
      /* 14.1 Brønsted-Lowry Acids and Bases to the same module in 2e */
      'a5478279-3d32-4d9f-a8a1-4a6f2c35e4b1': '2417915b-962d-4273-8f79-a8744124a6a5',
      /* 14.2 pH and pOH to the same module in 2e */
      'bbdc5e91-d867-400f-a5bc-2678ecc61e86': '9b866cac-4fb8-4db9-a92c-2cb4cabeefd0',
      /* 14.3 Relative Strengths of Acids and Bases to the same module in 2e */
      '64b7990f-3343-41b2-b0cb-ddf487e91677': '5405aa2f-8793-467b-ae1d-1795f1142207',
      /* 14.4 Hydrolysis of Salt Solutions to Ch 14 Acid-Base Equilibria: 14.4 Hydrolysis of Salts in 2e */
      'fb408cf1-40d1-48d0-a575-678ceaeec371': 'df527820-3877-419d-97a3-62386ce24df9',
      /* 14.5 Polyprotic Acids to the same module in 2e */
      '7a3e3046-b36f-44f3-937d-d496aa6c77ca': '6ef9fbf2-7ff5-430d-9847-cbcc21045286',
      /* 14.6 Buffers to the same module in 2e */
      '6f8c4f38-d4ba-4fad-874c-3356f0b52330': '2e4b2717-6fb3-4f91-a019-0a99b8b01921',
      /* 14.7 Acid-Base Titrations to the same module in 2e */
      'e62c4355-3d42-4c31-b54a-ec5f82d8c0dd': '617eab8e-758e-4510-be4c-8d9252cf4632',
      /* 15.0 Introduction to the same module in 2e */
      'ae40bb04-c4fa-4c4b-9695-13b132fc6f40': '8d42ec0e-c529-4663-ac18-2f41a286c668',
      /* 15.1 Precipitation and Dissolution to the same module in 2e */
      'bc9d4b8e-9936-4e2e-aee6-b8edd76aeff7': '12ccafb5-1b00-4ffd-81c3-dfc8b9fa2959',
      /* 15.2 Lewis Acids and Bases to the same module in 2e */
      '6ae949d9-1df4-4224-9514-415d050158ec': '7ef9f54c-741b-4311-bbde-d1024521b771',
      /* 15.3 Multiple Equilibria to Ch 15 Equilibria of Other Reaction Classes: 15.3 Coupled Equilibria in 2e */
      '7c8dd719-ad5b-4eb9-b798-c8c05146fcdb': 'ea7735a0-36bd-4f45-b0d7-13aa92a3f9b9',
      /* 16.0 Introduction to the same module in 2e */
      'fe7a0312-a2a7-46af-b001-ba187ae8547a': '7c92f9c8-534d-4d39-ac6c-cbb9798c92da',
      /* 16.1 Balancing Oxidation-Reduction Reactions to Ch 16 Electrochemistry: 16.1 Review of Redox Chemistry in 2e */
      'f17f0b23-0f90-4794-a5a9-8d06c5bb2ba2': '254840ff-5389-46ad-a965-7cf28005829a',
      /* 16.2 Galvanic Cells to the same module in 2e */
      'c5276fa4-ad96-4af7-8a14-aa887169de1f': '0c42f90c-4ac9-4e47-aab3-9beca85e4687',
      /* 16.3 Standard Reduction Potentials to Ch 16 Electrochemistry: 16.3 Electrode and Cell Potentials in 2e */
      'e1174d7a-cf56-4722-9e86-8e3fac4a67ac': '377d0ae5-0579-4942-8213-ff54fe1ae112',
      /* 16.4 The Nernst Equation to Ch 16 Electrochemistry: 16.4 Potential, Free Energy, and Equilibrium in 2e */
      'cf7f3322-a268-4266-9bc8-78d9cc443984': '8027ad43-75a9-47d8-8ee6-da2125ceb96f',
      /* 16.5 Batteries and Fuel Cells to the same module in 2e */
      'ca4a9d8d-d103-4581-bd9d-d2ca537dbb10': '7c891b2b-af9e-411f-af9c-f6cc43c9ca1b',
      /* 16.6 Corrosion to the same module in 2e */
      '9c220835-c03f-44ea-9257-2a511e02a17d': '60dc4797-103d-4ebd-949a-5f51bffefec6',
      /* 16.7 Electrolysis to the same module in 2e */
      '05bb5436-68d3-4297-8c58-cb2116f54b6f': 'f7da8e5d-7d8b-4d26-88dd-fe48dbc498ab',
      /* 17.0 Introduction to the same module in 2e */
      '37769ab3-d8e7-4035-969c-46e9e57e0c36': '9d111d7d-7cb8-4688-9cd2-46774c477da9',
      /* 17.1 Chemical Reaction Rates to the same module in 2e */
      '98d71893-c249-4af2-ba28-20baa7abef20': '19ee5333-b3d6-42c0-9ee6-ca6fcf3b1c62',
      /* 17.2 Factors Affecting Reaction Rates to the same module in 2e */
      '148be6b0-bf85-4601-9634-a727fd91b8ce': '7ce1385c-f564-4c79-be86-20dce552bcb6',
      /* 17.3 Rate Laws to the same module in 2e */
      'ee11a7f2-c2bf-4ee6-979d-ae8e3001f786': 'eac21754-bb36-49fa-9fa1-6ea0c734ee22',
      /* 17.4 Integrated Rate Laws to the same module in 2e */
      'df19bc9c-1aab-414d-8e79-acd74d7de0e6': '75b26e56-10ff-4bef-b887-3caa982b223a',
      /* 17.5 Collision Theory to the same module in 2e */
      '0ca2f90f-15d3-4e94-a6a3-d96b10dafb33': 'c63c9485-0971-4fce-a831-9d1b2ace526a',
      /* 17.6 Reaction Mechanisms to the same module in 2e */
      '983d7203-f8ee-4745-ab98-816466e7bacc': '5e902df9-c745-4aa6-a971-669706f327a2',
      /* 17.7 Catalysis to the same module in 2e */
      '6d9befd8-f314-4278-a2a7-b0afeda06338': '40651eeb-28e7-4577-9bf7-d42282ec6ae5',
      /* 18.0 Introduction to the same module in 2e */
      'e86d2342-1ecb-4a9c-85c9-a69ec77bd1bc': 'aa4dab2c-4908-4a31-bc42-1af345c323c6',
      /* 18.1 Periodicity to the same module in 2e */
      'a64c6bc7-5ab1-4cf7-a23f-c40c1c35eb73': 'f7224d2a-76cb-49f8-91ba-915271b912af',
      /* 18.2 Occurrence and Preparation of the Representative Metals to the same module in 2e */
      'a12b5c95-857c-4b5f-898f-533d96d14a4f': 'bc580803-a608-4004-95be-e5c48156136c',
      /* 18.3 Structure and General Properties of the Metalloids to the same module in 2e */
      'a9254810-9f64-4982-9419-c562bed791b7': '204b5ad5-26eb-46d5-8e6c-3c224a904235',
      /* 18.4 Structure and General Properties of the Nonmetals to the same module in 2e */
      'be8687a3-00c2-40ab-89e2-e2481af602a8': '0d29d8b1-83b0-49c3-961f-7f622017873e',
      /* 18.5 Occurrence, Preparation, and Compounds of Hydrogen to the same module in 2e */
      '54eb0e77-ce1f-4b62-91a6-a486e35eedf4': '04b97d13-490d-4732-8eb9-221fe8062387',
      /* 18.6 Occurrence, Preparation, and Properties of Carbonates to the same module in 2e */
      '3f2884a2-eb44-4b9f-a1f0-ca6668581551': '9832ddaa-8e9b-4b71-a979-b6e815242dd8',
      /* 18.7 Occurrence, Preparation, and Properties of Nitrogen to the same module in 2e */
      '1481832b-c3f3-4f7f-8102-1ba498666b1c': 'fa6592b5-4723-4955-816d-2a0d46641b8c',
      /* 18.8 Occurrence, Preparation, and Properties of Phosphorus to the same module in 2e */
      'ed2e0a48-dbf9-4004-b45d-b7e56bff34fa': '4121db69-abc4-44ab-b659-373f244a35bc',
      /* 18.9 Occurrence, Preparation, and Compounds of Oxygen to the same module in 2e */
      'dffe8fcc-9597-4dca-9e7b-4cc78fc3f50c': 'a8895b18-d450-4bf2-a847-ccfab75780ec',
      /* 18.10 Occurrence, Preparation, and Properties of Sulfur to the same module in 2e */
      '4e6ea39b-0a6b-48a3-8fe8-da1f83179ef5': '03b0d669-3f4e-450d-a7be-1108051b9f47',
      /* 18.11 Occurrence, Preparation, and Properties of Halogens to the same module in 2e */
      '3ea75b92-7e42-4f74-b7da-144cab31538d': '8868d0bc-22c9-4dff-abcd-28ed4c40aae2',
      /* 18.12 Occurrence, Preparation, and Properties of the Noble Gases to the same module in 2e */
      '15b0d34d-3a2d-495e-a477-8f947338866f': '06383b4a-d41b-4bfe-b776-b4431f8c446a',
      /* 19.0 Introduction to the same module in 2e */
      'b08273af-7ebe-4998-be20-3d67dcbbb51b': 'ab46f6de-1fc7-46c5-93e2-7b8fc2159976',
      /* 19.1 Occurrence, Preparation, and Properties of Transition Metals and Their Compounds to the same module in 2e */
      'a0a775ff-2eef-4c1d-b8ef-8b4f293972e7': 'f34d3f79-2f26-4b2f-be4c-ac5866935553',
      /* 19.2 Coordination Chemistry of Transition Metals to the same module in 2e */
      '579cdc76-8528-4680-9beb-febcec5c2893': '21374116-b20b-4092-8a9d-0a89dfc7920e',
      /* 19.3 Spectroscopic and Magnetic Properties of Coordination Compounds to the same module in 2e */
      '231ae9fb-2cb5-453e-88f0-d00ed65fc5bb': '4a918153-5a57-41ce-b908-fc035ade7c1e',
      /* 20.0 Introduction to the same module in 2e */
      '3fe6a912-6676-4312-98cb-fe862730c7c3': '242a0400-57dd-4b92-a971-19ed2c94b9c6',
      /* 20.1 Nuclear Structure and Stability to the same module in 2e */
      '47321f47-1a62-4cb9-84fb-1085b26252b3': '45860792-c5d9-436b-8bcf-3807f257eab6',
      /* 20.2 Nuclear Equations to the same module in 2e */
      '7daefecc-7636-4e2b-a2bf-4d5f29ac3a7f': '928aa888-145d-44e7-8249-6c08876d50ff',
      /* 20.3 Radioactive Decay to the same module in 2e */
      '9abb7cd9-d0b3-4131-bf8b-7a582e07fcaf': '3952d555-bfd0-4527-94d4-17af3703ea9e',
      /* 20.4 Transmutation and Nuclear Energy to the same module in 2e */
      '1aacfeeb-aabe-4c0c-9a0c-baff88dc7cf4': '642a0e3e-a83d-4a0f-8898-feba31e555bd',
      /* 20.5 Uses of Radioisotopes to the same module in 2e */
      '7ce1efca-b8fa-41c8-97ca-5367480c123e': '15be4435-4470-4cb9-b6ce-fdb871aba9f1',
      /* 20.6 Biological Effects of Radiation to the same module in 2e */
      '9664a115-e0d6-4bfb-b90f-65eb1de7d7f6': 'f2f866c2-bcfb-434a-b3f4-918cbd2c61de',
      /* 21.0 Introduction to the same module in 2e */
      '54d9fe43-aae3-4d00-8cc2-0fe97c4be5f2': 'a846bf55-732b-4e0b-b959-570ea8cf13e4',
      /* 21.1 Hydrocarbons to the same module in 2e */
      '9c8a6cc8-6f47-4ef4-9a85-8d1a755354ee': '20492b99-bcb4-4820-90e5-68b69b3cdb49',
      /* 21.2 Alcohols and Ethers to the same module in 2e */
      '0c244a79-450a-490b-8b59-602a5791d277': '8a5a66ca-b690-4656-8bf4-ce10c3d6786e',
      /* 21.3 Aldehydes, Ketones, Carboxylic Acids, and Esters to the same module in 2e */
      '2bf48f7a-940e-4eee-860f-1692a2c998b5': '5b973783-ed86-4363-9600-4e10fd316b90',
      /* 21.4 Amines and Amides to the same module in 2e */
      'bb13fed9-5f67-4260-acb7-20146a8f2193': '5f6bcc43-ab2c-48ff-8cf0-115f6697f8ce',
      /* The Periodic Table of Elements to the same module in 2e */
      'abe37363-0fb4-4018-868f-8ccc3ce7cad0': 'dff91a60-20dc-4c42-9824-1c616ee6a1c6',
      /* Essential Mathematics to the same module in 2e */
      '9e30ec42-520e-49d8-ab8b-177801a7dfae': '75fe9b6d-533d-4833-ba91-a70d2a794b2a',
      /* Unit and Conversion Factors to the same module in 2e */
      '5b86fa37-ce91-485e-9da5-554eb69fbea7': 'eeaf98f0-ce83-4e1c-ae20-dd05515645b4',
      /* Fundamental Physical Constants to the same module in 2e */
      'ac3c6063-c724-481e-8868-ab093e116d60': '89acae8f-68fd-4f9e-88e3-e545c290c96c',
      /* Water Properties to the same module in 2e */
      '6c88b20d-e0cd-4a3a-8c9a-365ee1a74aab': '99f9a1dc-5a53-4300-af88-5529ddcd7fd1',
      /* Composition of Commercial Acids and Bases to the same module in 2e */
      '95d44348-7dcc-4a2c-9cc1-d1dd30068fee': '6bf34cfc-a0bd-44e3-b418-27e44b50baf3',
      /* Standard Enthalpies of Formation, Standard Free Energies of Formation, and Absolute Standard Entropies to the same module in 2e */
      'da076442-9614-4d57-92ab-d045b9331829': '667adccf-f900-4d86-a13d-409c014086ea',
      /* Ionization Constants of Weak Acids to the same module in 2e */
      '6bb1b6bb-d9ee-4a4d-870b-7cbb426a694d': '648466ce-e59f-49d4-9b54-3bb68cb15801',
      /* Ionization Constants of Weak Bases to the same module in 2e */
      '51367954-3059-4d30-8506-9813b2d2ac97': 'c20e2e13-3e0c-4bb5-a07f-0e220bf1b501',
      /* Solubility Products to the same module in 2e */
      'b9b69dd3-b384-47d1-890e-359a490bed8a': 'de95d7fb-f6c6-49e0-91b7-cefe0ccbb151',
      /* Formation Constants for Complex Ions to the same module in 2e */
      'faa811c3-a195-4210-99c1-9a1397fcfc3c': '837210f4-02c3-4a18-a1a2-7d3c3477cb5b',
      /* Standard Electrode (Half-Cell) Potentials to the same module in 2e */
      'eeb4f06e-96a2-4be1-b910-001bbee233e8': '562b4d8d-bd3c-4837-9946-08d8be397584',
      /* Half-Lives for Several Radioactive Isotopes to the same module in 2e */
      '488957cf-0946-4d2d-bf51-ce6ffe008925': 'f4401758-74d6-459b-9c6d-52055945a1d1',
    }],
  ],
} as CanonicalBookMap;
